import { Students } from '@/@types/models/Students'

export const SORTED_ASCENDING = 'asc'

export const SORTED_DESCENDING = 'desc'

export const INITIAL_VALUE_ORDER_BY: keyof Students = 'nome'

export const INITIAL_VALUE_ROWS_PER_PAGE = 5
